import React from 'react';
import DaoSections from '../../components/PTGC/dao/index';  // ✅ Fix import

const DaoPage = () => {
  return (
    <>
      <DaoSections />  {/* ✅ Fix component usage */}
    </>
  );
};

export default DaoPage;